import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/finalPlan/findBasicConfigData`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
